/* eslint-disable max-len */
/**
 * ブロック検索用の定義データ
 * 各ブロックの type, カテゴリID, 表示名（多言語対応）を含む
 */

const BLOCK_DEFINITIONS = [
    // === Motion ===
    {type: 'motion_movesteps', category: 'motion', name: {en: 'move steps', ja: '歩動かす'}},
    {type: 'motion_turnright', category: 'motion', name: {en: 'turn right', ja: '右に回す'}},
    {type: 'motion_turnleft', category: 'motion', name: {en: 'turn left', ja: '左に回す'}},
    {type: 'motion_goto', category: 'motion', name: {en: 'go to', ja: 'へ行く'}},
    {type: 'motion_gotoxy', category: 'motion', name: {en: 'go to x y', ja: 'x座標 y座標へ行く'}},
    {type: 'motion_glideto', category: 'motion', name: {en: 'glide to', ja: '秒でへ行く'}},
    {type: 'motion_glidesecstoxy', category: 'motion', name: {en: 'glide secs to x y', ja: '秒でx座標y座標へ行く'}},
    {type: 'motion_pointindirection', category: 'motion', name: {en: 'point in direction', ja: '度に向ける'}},
    {type: 'motion_pointtowards', category: 'motion', name: {en: 'point towards', ja: 'へ向ける'}},
    {type: 'motion_changexby', category: 'motion', name: {en: 'change x by', ja: 'x座標を変える'}},
    {type: 'motion_setx', category: 'motion', name: {en: 'set x to', ja: 'x座標を〜にする'}},
    {type: 'motion_changeyby', category: 'motion', name: {en: 'change y by', ja: 'y座標を変える'}},
    {type: 'motion_sety', category: 'motion', name: {en: 'set y to', ja: 'y座標を〜にする'}},
    {type: 'motion_ifonedgebounce', category: 'motion', name: {en: 'if on edge bounce', ja: 'もし端に着いたら跳ね返る'}},
    {type: 'motion_setrotationstyle', category: 'motion', name: {en: 'set rotation style', ja: '回転方法を〜にする'}},
    {type: 'motion_xposition', category: 'motion', name: {en: 'x position', ja: 'x座標'}},
    {type: 'motion_yposition', category: 'motion', name: {en: 'y position', ja: 'y座標'}},
    {type: 'motion_direction', category: 'motion', name: {en: 'direction', ja: '向き'}},

    // === Looks ===
    {type: 'looks_sayforsecs', category: 'looks', name: {en: 'say for seconds', ja: '秒言う'}},
    {type: 'looks_say', category: 'looks', name: {en: 'say', ja: '言う'}},
    {type: 'looks_thinkforsecs', category: 'looks', name: {en: 'think for seconds', ja: '秒考える'}},
    {type: 'looks_think', category: 'looks', name: {en: 'think', ja: '考える'}},
    {type: 'looks_switchcostumeto', category: 'looks', name: {en: 'switch costume to', ja: 'コスチュームを〜にする'}},
    {type: 'looks_nextcostume', category: 'looks', name: {en: 'next costume', ja: '次のコスチュームにする'}},
    {type: 'looks_switchbackdropto', category: 'looks', name: {en: 'switch backdrop to', ja: '背景を〜にする'}},
    {type: 'looks_switchbackdroptoandwait', category: 'looks', name: {en: 'switch backdrop to and wait', ja: '背景を〜にして待つ'}},
    {type: 'looks_nextbackdrop', category: 'looks', name: {en: 'next backdrop', ja: '次の背景にする'}},
    {type: 'looks_changesizeby', category: 'looks', name: {en: 'change size by', ja: '大きさを変える'}},
    {type: 'looks_setsizeto', category: 'looks', name: {en: 'set size to', ja: '大きさを〜%にする'}},
    {type: 'looks_changeeffectby', category: 'looks', name: {en: 'change effect by', ja: '効果を変える'}},
    {type: 'looks_seteffectto', category: 'looks', name: {en: 'set effect to', ja: '効果を〜にする'}},
    {type: 'looks_cleargraphiceffects', category: 'looks', name: {en: 'clear graphic effects', ja: '画像効果をなくす'}},
    {type: 'looks_show', category: 'looks', name: {en: 'show', ja: '表示する'}},
    {type: 'looks_hide', category: 'looks', name: {en: 'hide', ja: '隠す'}},
    {type: 'looks_gotofrontback', category: 'looks', name: {en: 'go to front/back layer', ja: '最前面/最背面へ移動する'}},
    {type: 'looks_goforwardbackwardlayers', category: 'looks', name: {en: 'go forward/backward layers', ja: '層前/後に出す'}},
    {type: 'looks_costumenumbername', category: 'looks', name: {en: 'costume number/name', ja: 'コスチュームの番号/名前'}},
    {type: 'looks_backdropnumbername', category: 'looks', name: {en: 'backdrop number/name', ja: '背景の番号/名前'}},
    {type: 'looks_size', category: 'looks', name: {en: 'size', ja: '大きさ'}},

    // === Sound ===
    {type: 'sound_playuntildone', category: 'sound', name: {en: 'play sound until done', ja: '終わるまで音を鳴らす'}},
    {type: 'sound_play', category: 'sound', name: {en: 'start sound', ja: '音を鳴らす'}},
    {type: 'sound_stopallsounds', category: 'sound', name: {en: 'stop all sounds', ja: 'すべての音を止める'}},
    {type: 'sound_changeeffectby', category: 'sound', name: {en: 'change sound effect by', ja: '音の効果を変える'}},
    {type: 'sound_seteffectto', category: 'sound', name: {en: 'set sound effect to', ja: '音の効果を〜にする'}},
    {type: 'sound_cleareffects', category: 'sound', name: {en: 'clear sound effects', ja: '音の効果をなくす'}},
    {type: 'sound_changevolumeby', category: 'sound', name: {en: 'change volume by', ja: '音量を変える'}},
    {type: 'sound_setvolumeto', category: 'sound', name: {en: 'set volume to', ja: '音量を〜%にする'}},
    {type: 'sound_volume', category: 'sound', name: {en: 'volume', ja: '音量'}},

    // === Events ===
    {type: 'event_whenflagclicked', category: 'event', name: {en: 'when flag clicked', ja: '旗が押されたとき'}},
    {type: 'event_whenkeypressed', category: 'event', name: {en: 'when key pressed', ja: 'キーが押されたとき'}},
    {type: 'event_whenthisspriteclicked', category: 'event', name: {en: 'when this sprite clicked', ja: 'このスプライトが押されたとき'}},
    {type: 'event_whenstageclicked', category: 'event', name: {en: 'when stage clicked', ja: 'ステージが押されたとき'}},
    {type: 'event_whenbackdropswitchesto', category: 'event', name: {en: 'when backdrop switches to', ja: '背景が〜になったとき'}},
    {type: 'event_whengreaterthan', category: 'event', name: {en: 'when greater than', ja: '〜が〜より大きいとき'}},
    {type: 'event_whenbroadcastreceived', category: 'event', name: {en: 'when I receive', ja: 'を受け取ったとき'}},
    {type: 'event_broadcast', category: 'event', name: {en: 'broadcast', ja: 'を送る'}},
    {type: 'event_broadcastandwait', category: 'event', name: {en: 'broadcast and wait', ja: 'を送って待つ'}},

    // === Control ===
    {type: 'control_wait', category: 'control', name: {en: 'wait seconds', ja: '秒待つ'}},
    {type: 'control_repeat', category: 'control', name: {en: 'repeat', ja: '回繰り返す'}},
    {type: 'control_forever', category: 'control', name: {en: 'forever', ja: 'ずっと'}},
    {type: 'control_if', category: 'control', name: {en: 'if then', ja: 'もし〜なら'}},
    {type: 'control_if_else', category: 'control', name: {en: 'if then else', ja: 'もし〜でなければ'}},
    {type: 'control_wait_until', category: 'control', name: {en: 'wait until', ja: 'まで待つ'}},
    {type: 'control_repeat_until', category: 'control', name: {en: 'repeat until', ja: 'まで繰り返す'}},
    {type: 'control_stop', category: 'control', name: {en: 'stop', ja: '止める'}},
    {type: 'control_start_as_clone', category: 'control', name: {en: 'when I start as a clone', ja: 'クローンされたとき'}},
    {type: 'control_create_clone_of', category: 'control', name: {en: 'create clone of', ja: 'のクローンを作る'}},
    {type: 'control_delete_this_clone', category: 'control', name: {en: 'delete this clone', ja: 'このクローンを削除する'}},

    // === Sensing ===
    {type: 'sensing_touchingobject', category: 'sensing', name: {en: 'touching', ja: 'に触れた'}},
    {type: 'sensing_touchingcolor', category: 'sensing', name: {en: 'touching color', ja: '色に触れた'}},
    {type: 'sensing_coloristouchingcolor', category: 'sensing', name: {en: 'color is touching color', ja: '色が色に触れた'}},
    {type: 'sensing_distanceto', category: 'sensing', name: {en: 'distance to', ja: 'までの距離'}},
    {type: 'sensing_askandwait', category: 'sensing', name: {en: 'ask and wait', ja: 'と聞いて待つ'}},
    {type: 'sensing_answer', category: 'sensing', name: {en: 'answer', ja: '答え'}},
    {type: 'sensing_keypressed', category: 'sensing', name: {en: 'key pressed', ja: 'キーが押された'}},
    {type: 'sensing_mousedown', category: 'sensing', name: {en: 'mouse down', ja: 'マウスが押された'}},
    {type: 'sensing_mousex', category: 'sensing', name: {en: 'mouse x', ja: 'マウスのx座標'}},
    {type: 'sensing_mousey', category: 'sensing', name: {en: 'mouse y', ja: 'マウスのy座標'}},
    {type: 'sensing_setdragmode', category: 'sensing', name: {en: 'set drag mode', ja: 'ドラッグモードを〜にする'}},
    {type: 'sensing_loudness', category: 'sensing', name: {en: 'loudness', ja: '音量'}},
    {type: 'sensing_timer', category: 'sensing', name: {en: 'timer', ja: 'タイマー'}},
    {type: 'sensing_resettimer', category: 'sensing', name: {en: 'reset timer', ja: 'タイマーをリセット'}},
    {type: 'sensing_of', category: 'sensing', name: {en: 'of', ja: 'の〜'}},
    {type: 'sensing_current', category: 'sensing', name: {en: 'current', ja: '現在の〜'}},
    {type: 'sensing_dayssince2000', category: 'sensing', name: {en: 'days since 2000', ja: '2000年からの日数'}},
    {type: 'sensing_username', category: 'sensing', name: {en: 'username', ja: 'ユーザー名'}},

    // === Operators ===
    {type: 'operator_add', category: 'operators', name: {en: 'add', ja: '足す +'}},
    {type: 'operator_subtract', category: 'operators', name: {en: 'subtract', ja: '引く -'}},
    {type: 'operator_multiply', category: 'operators', name: {en: 'multiply', ja: 'かける *'}},
    {type: 'operator_divide', category: 'operators', name: {en: 'divide', ja: '割る /'}},
    {type: 'operator_random', category: 'operators', name: {en: 'pick random', ja: '〜から〜までの乱数'}},
    {type: 'operator_gt', category: 'operators', name: {en: 'greater than', ja: 'より大きい >'}},
    {type: 'operator_lt', category: 'operators', name: {en: 'less than', ja: 'より小さい <'}},
    {type: 'operator_equals', category: 'operators', name: {en: 'equals', ja: '等しい ='}},
    {type: 'operator_and', category: 'operators', name: {en: 'and', ja: 'かつ'}},
    {type: 'operator_or', category: 'operators', name: {en: 'or', ja: 'または'}},
    {type: 'operator_not', category: 'operators', name: {en: 'not', ja: 'ではない'}},
    {type: 'operator_join', category: 'operators', name: {en: 'join', ja: 'と〜'}},
    {type: 'operator_letter_of', category: 'operators', name: {en: 'letter of', ja: '〜番目の文字'}},
    {type: 'operator_length', category: 'operators', name: {en: 'length of', ja: 'の長さ'}},
    {type: 'operator_contains', category: 'operators', name: {en: 'contains', ja: '〜が含まれる'}},
    {type: 'operator_mod', category: 'operators', name: {en: 'mod', ja: 'を〜で割った余り'}},
    {type: 'operator_round', category: 'operators', name: {en: 'round', ja: '四捨五入'}},
    {type: 'operator_mathop', category: 'operators', name: {en: 'math operation', ja: '数学関数'}},

    // === Variables ===
    {type: 'data_setvariableto', category: 'data', name: {en: 'set variable to', ja: '変数を〜にする'}},
    {type: 'data_changevariableby', category: 'data', name: {en: 'change variable by', ja: '変数を〜ずつ変える'}},
    {type: 'data_showvariable', category: 'data', name: {en: 'show variable', ja: '変数を表示する'}},
    {type: 'data_hidevariable', category: 'data', name: {en: 'hide variable', ja: '変数を隠す'}},
    {type: 'data_addtolist', category: 'data', name: {en: 'add to list', ja: 'をリストに追加する'}},
    {type: 'data_deleteoflist', category: 'data', name: {en: 'delete of list', ja: '番目をリストから削除する'}},
    {type: 'data_deletealloflist', category: 'data', name: {en: 'delete all of list', ja: 'リストのすべてを削除する'}},
    {type: 'data_insertatlist', category: 'data', name: {en: 'insert at list', ja: '番目に〜を挿入する'}},
    {type: 'data_replaceitemoflist', category: 'data', name: {en: 'replace item of list', ja: '番目を〜で置き換える'}},
    {type: 'data_itemoflist', category: 'data', name: {en: 'item of list', ja: '〜番目'}},
    {type: 'data_itemnumoflist', category: 'data', name: {en: 'item # of in list', ja: 'がリストにある場所'}},
    {type: 'data_lengthoflist', category: 'data', name: {en: 'length of list', ja: 'リストの長さ'}},
    {type: 'data_listcontainsitem', category: 'data', name: {en: 'list contains', ja: 'リストに〜が含まれる'}},
    {type: 'data_showlist', category: 'data', name: {en: 'show list', ja: 'リストを表示する'}},
    {type: 'data_hidelist', category: 'data', name: {en: 'hide list', ja: 'リストを隠す'}},

    // === My Blocks ===
    {type: 'procedures_definition', category: 'myBlocks', name: {en: 'define', ja: '定義'}},
    {type: 'procedures_call', category: 'myBlocks', name: {en: 'my block', ja: 'ブロック'}}
];

// カテゴリ情報
const CATEGORIES = {
    motion: {name: {en: 'Motion', ja: '動き'}, color: '#4C97FF'},
    looks: {name: {en: 'Looks', ja: '見た目'}, color: '#9966FF'},
    sound: {name: {en: 'Sound', ja: '音'}, color: '#CF63CF'},
    event: {name: {en: 'Events', ja: 'イベント'}, color: '#FFBF00'},
    control: {name: {en: 'Control', ja: '制御'}, color: '#FFAB19'},
    sensing: {name: {en: 'Sensing', ja: '調べる'}, color: '#5CB1D6'},
    operators: {name: {en: 'Operators', ja: '演算'}, color: '#59C059'},
    data: {name: {en: 'Variables', ja: '変数'}, color: '#FF8C1A'},
    myBlocks: {name: {en: 'My Blocks', ja: 'ブロック定義'}, color: '#FF6680'}
};

/**
 * ブロックを検索する
 * @param {string} query - 検索クエリ
 * @param {string} locale - ロケール（'ja', 'en' など）
 * @returns {Array} マッチしたブロック定義の配列
 */
export const searchBlocks = (query, locale = 'ja') => {
    if (!query || query.trim() === '') {
        return [];
    }

    const normalizedQuery = query.toLowerCase().trim();
    const lang = locale.startsWith('ja') ? 'ja' : 'en';

    return BLOCK_DEFINITIONS.filter(block => {
        const blockName = block.name[lang] || block.name.en;
        const categoryInfo = CATEGORIES[block.category];
        const categoryName = categoryInfo ? (categoryInfo.name[lang] || categoryInfo.name.en) : '';

        return (
            blockName.toLowerCase().includes(normalizedQuery) ||
            block.type.toLowerCase().includes(normalizedQuery) ||
            categoryName.toLowerCase().includes(normalizedQuery)
        );
    }).map(block => ({
        ...block,
        displayName: block.name[lang] || block.name.en,
        categoryInfo: CATEGORIES[block.category]
    }));
};

/**
 * カテゴリIDからカテゴリ情報を取得
 * @param {string} categoryId - カテゴリID
 * @returns {object} カテゴリ情報
 */
export const getCategoryInfo = categoryId => CATEGORIES[categoryId] || null;

/**
 * 拡張機能のブロックを検索する
 * @param {Array} blockInfoArray - vm.runtime._blockInfo から取得した拡張機能情報
 * @param {string} query - 検索クエリ
 * @returns {Array} マッチしたブロック定義の配列
 */
export const getExtensionBlocks = (blockInfoArray, query) => {
    if (!query || query.trim() === '' || !blockInfoArray) {
        return [];
    }

    const normalizedQuery = query.toLowerCase().trim();
    const results = [];

    for (const extensionInfo of blockInfoArray) {
        const extensionId = extensionInfo.id;
        const extensionName = extensionInfo.name || extensionId;
        const extensionColor = extensionInfo.color1 || '#888888';

        // 拡張機能のカテゴリ情報を作成
        const categoryInfo = {
            name: {en: extensionName, ja: extensionName},
            color: extensionColor
        };

        // この拡張機能のブロックを検索
        if (extensionInfo.blocks) {
            for (const block of extensionInfo.blocks) {
                // ボタンやセパレーターはスキップ
                if (block.info && (block.info.type === 'button' || block.info.type === 'label')) {
                    continue;
                }
                if (typeof block === 'string') {
                    // セパレーター "---" などはスキップ
                    continue;
                }

                // ブロックのテキストを取得
                let blockText = '';
                if (block.info && block.info.text) {
                    blockText = block.info.text;
                } else if (block.text) {
                    blockText = block.text;
                } else if (block.json && block.json.message0) {
                    blockText = block.json.message0;
                }

                // プレースホルダーを除去 ([ICON] や %1 など)
                blockText = blockText
                    .replace(/\[.*?\]/g, '')
                    .replace(/%\d+/g, '')
                    .trim();

                const blockType = block.info?.opcode ?
                    `${extensionId}_${block.info.opcode}` :
                    (block.json?.type || extensionId);

                // 検索条件にマッチするかチェック
                const matchesQuery = (
                    blockText.toLowerCase().includes(normalizedQuery) ||
                    blockType.toLowerCase().includes(normalizedQuery) ||
                    extensionName.toLowerCase().includes(normalizedQuery)
                );

                if (matchesQuery && blockText) {
                    results.push({
                        type: blockType,
                        category: extensionId,
                        name: {en: blockText, ja: blockText},
                        displayName: blockText,
                        categoryInfo: categoryInfo,
                        isExtension: true
                    });
                }
            }
        }
    }

    return results;
};

export {BLOCK_DEFINITIONS, CATEGORIES};
export default BLOCK_DEFINITIONS;
